/* Project-T: Cinematic Hero behavior (v2.1)
 * - Fade-in animation trigger
 * - Scroll indicator click-to-scroll
 * - Gentle mouse parallax (desktop, pointer-fine only)
 * - Reduced-motion + motion-toggle aware
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  var hasFinePointer = window.matchMedia('(pointer: fine)').matches;

  function initHero(hero) {
    var content = hero.querySelector('.pt-hero__content');
    var indicator = hero.querySelector('.pt-hero__scroll-indicator');
    var motionEnabled = hero.getAttribute('data-pt-motion') === 'true' && !prefersReducedMotion;

    // Fade-in
    if (!motionEnabled && prefersReducedMotion) {
      if (content) content.classList.add('pt-is-visible');
      if (indicator) indicator.classList.add('pt-is-visible');
    } else if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (content) content.classList.add('pt-is-visible');
              if (indicator) indicator.classList.add('pt-is-visible');
              observer.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(hero);
    } else {
      if (content) content.classList.add('pt-is-visible');
      if (indicator) indicator.classList.add('pt-is-visible');
    }

    // Scroll indicator
    if (indicator) {
      indicator.addEventListener('click', function () {
        var next = hero.nextElementSibling;
        if (next) {
          next.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'start',
          });
        } else {
          window.scrollBy({
            top: window.innerHeight,
            left: 0,
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
          });
        }
      });
    }

    // Mouse parallax
    if (motionEnabled && hasFinePointer) {
      var maxShift = 14; // px
      var raf = null;
      var targetX = 0;
      var targetY = 0;

      hero.addEventListener('mousemove', function (e) {
        var rect = hero.getBoundingClientRect();
        var relX = (e.clientX - rect.left) / rect.width - 0.5;
        var relY = (e.clientY - rect.top) / rect.height - 0.5;
        targetX = relX * maxShift;
        targetY = relY * maxShift;

        if (!raf) {
          raf = requestAnimationFrame(function () {
            hero.style.setProperty('--pt-mx', targetX.toFixed(2) + 'px');
            hero.style.setProperty('--pt-my', targetY.toFixed(2) + 'px');
            raf = null;
          });
        }
      });

      hero.addEventListener('mouseleave', function () {
        hero.style.setProperty('--pt-mx', '0px');
        hero.style.setProperty('--pt-my', '0px');
      });
    }
  }

  function initProductRack() {
    var section = document.getElementById('shopify-section-product_list_themegen');
    if (!section) return;

    var items = section.querySelectorAll('.resource-list__item');
    if (!items.length) return;

    if (prefersReducedMotion) {
      items.forEach(function (item) {
        item.classList.add('pt-rack-visible');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('pt-rack-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var item = entry.target;
            var index = Array.prototype.indexOf.call(items, item);
            var delay = Math.min(index, 11) * 80;
            item.style.transitionDelay = delay + 'ms';
            item.classList.add('pt-rack-visible');
            observer.unobserve(item);
          }
        });
      },
      { threshold: 0.1 }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function init() {
    var heroes = document.querySelectorAll('.pt-hero');
    heroes.forEach(initHero);

    initProductRack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Project-T: Global premium polish (v3.0 final pass) — additive only */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  var hasFinePointer = window.matchMedia('(pointer: fine)').matches;

  // Header: add a scrolled state for glass/blur styling
  function initHeaderScrollState() {
    var header = document.getElementById('header-component');
    if (!header) return;

    function update() {
      var scrolled = window.scrollY > 12;
      header.setAttribute('data-pt-scrolled', scrolled ? 'true' : 'false');
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  // Generic fade-up reveal for footer content and any [data-pt-reveal] elements,
  // without touching Hero / Why We Exist / Rack / Quote (they already self-animate)
  function initGenericReveal() {
    var targets = [];
    var footerContent = document.querySelectorAll('.footer-content');
    footerContent.forEach(function (el) {
      targets.push(el);
    });

    if (!targets.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('pt-reveal-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pt-reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Light magnetic feeling on buttons: tiny cursor-following offset, desktop only
  function initMagneticButtons() {
    if (prefersReducedMotion || !hasFinePointer) return;

    var buttons = document.querySelectorAll(
      '.button, .button-secondary, a.button-unstyled, button.button-unstyled'
    );

    buttons.forEach(function (btn) {
      btn.setAttribute('data-pt-magnetic', 'true');
      var raf = null;
      var maxShift = 4; // px, very light

      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var relX = (e.clientX - rect.left) / rect.width - 0.5;
        var relY = (e.clientY - rect.top) / rect.height - 0.5;
        var tx = relX * maxShift;
        var ty = relY * maxShift;

        if (!raf) {
          raf = requestAnimationFrame(function () {
            btn.style.transform = 'translate(' + tx.toFixed(1) + 'px, ' + ty.toFixed(1) + 'px)';
            raf = null;
          });
        }
      });

      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  function init() {
    initHeaderScrollState();
    initGenericReveal();
    initMagneticButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Project-T: Footer refinement pass (v3.1) — additive only
 * Toggles a fade-up class on the footer section wrappers once they
 * enter the viewport (works alongside the generic reveal above).
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  function initFooterFadeUp() {
    var ids = ['shopify-section-section_jehhzd', 'shopify-section-footer_utilities'];
    var targets = ids
      .map(function (id) {
        return document.getElementById(id);
      })
      .filter(Boolean);

    if (!targets.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('pt-footer-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pt-footer-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterFadeUp);
  } else {
    initFooterFadeUp();
  }
})();
